<template>
  <div class="container">
    <app-header title="填写退货物流"/>

    <template v-if="data.shopOrder && data.shopOrder.orderItemList.length > 0">
      <div class="content" v-for="(item,index) in data.shopOrder.orderItemList" :key="index">
        <img :src="item.shopProduct.image" width="98px" height="98px" />
        <div class="messages">
          <div class="title1">{{item.shopProduct.name}}</div>
          <div class="price">￥{{item.totalPrice}}</div>
          <div class="mehint">已选: {{item.description}}</div>
        </div>
      </div>
    </template>

    <!--<div class="content" v-if="data.shopOrder.orderItemList.length > 0">-->
      <!--<img :src="data.shopOrder.orderItemList[0].shopProduct.image" width="98px" height="98px" />-->
      <!--<div class="messages">-->
        <!--<div class="title1">{{data.shopOrder.orderItemList[0].shopProduct.name}}</div>-->
        <!--<div class="price">￥{{data.shopOrder.orderItemList[0].price}}</div>-->
        <!--<div class="mehint">已选: {{data.shopOrder.orderItemList[0].description}}</div>-->
      <!--</div>-->
    <!--</div>-->

    <div style="height: 10px;background: #EDEDED"></div>
    <div class="refund-money">
      <div class="refund-title">
        <span style="color: #FE003B">*</span>
        <span>物流单号</span>
      </div>
      <div class="refund-value">
        <input class="refund-input" placeholder="请填写物流单号" v-model="form.shippingSn"></input>
      </div>
    </div>

    <div class="refund-money" @click="show = true">
      <div class="refund-title">
        <span style="color: #FE003B">*</span>
        <span>物流公司</span>
      </div>
      <div class="refund-value">
        <span>{{form.shippingName}}</span>
        <img src="@/assets/addgo.png" alt="" width="14px">
      </div>
    </div>

    <div class="refund-money">
      <div class="refund-title">
        <span style="color: #FE003B">*</span>
        <span>联系电话</span>
      </div>
      <div class="refund-value">
        <input class="refund-input" placeholder="请填写联系电话" v-model="form.phone"></input>
      </div>
    </div>

    <div class="submit" @click="submit()">提交</div>

    <van-popup v-model="show" round position="bottom" :style="{ height: '50%' }" >
      <div class="popup">
        <div class="popuphead">
          <div class="close" @click="show = false">
            <img src="@/assets/close.png" alt="" width="14px">
          </div>
          <div class="confirm" @click="show = false">确定</div>
        </div>
        <div class="type" @click="selectDesc(item)"
             v-for="(item,index) in expressList"
             :key="index"
             :class="active==index?'active':''">
          {{item.companyName}}</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import { image } from '@/api/file'
  import { updateShopProblem } from '@/api/mine/shopProblem.js'
  import { getShopProblem } from '@/api/order/index.js'
  import { getSysExpressCodingList } from '@/api/system/index.js'
  export default {
    name: "refund",
      data(){
        return{
          active: '',
          show:false,
          accept: 'image/*',
          // 图片列表
          fileList: [],
          expressList: [],
          data: {},
          form : {
            shippingName : '请选择',
            shippingCode : '',
            shippingSn : '',
            phone : '',
            uid : ''
          }
        }
      },
      created(){
        this.form.id = this.$route.query.pid
        this._getShopProblem();
        this.getExpressList();
      },
      methods:{
        getExpressList(){
          getSysExpressCodingList({}).then((res) => {
            if (res.success) {
              this.expressList = res.data
            }
          })
        },
        _getShopProblem () {
          var user = localStorage.getItem('userInfo')
          user = JSON.parse(user)
          const params = {
            uid: user.id,
            id: this.$route.query.pid,
          }
          getShopProblem(params).then((res) => {
            if (res.success) {
              this.data = res.data
            }
          })
        },
        selectDesc (item) {
          this.form.shippingName = item.companyName
          this.form.shippingCode = item.coding
          this.active = item.id
          this.show = false
        },

        submit () {
          var user = localStorage.getItem('userInfo')
          user = JSON.parse(user)
          if (!user){
            this.$router.push({
              path: '/login'
            })
            return;
          }
          if (!this.form.shippingSn) {
            this.$toast.fail('请输入快递单号')
            return;
          }
          if (!this.form.shippingCode) {
            this.$toast.fail('请选择快递公司')
            return;
          }
          if (!this.form.phone) {
            this.$toast.fail('请输入手机号码')
            return;
          }
          this.form.uid = user.id
          this.form.active = 3
          updateShopProblem(this.form).then(response => {
              if (response.code == "200") {
                this.$toast.success('提交成功，等待商家退款')
                setTimeout(() => {
                  this.$router.go(-1)
                },2000)
              } else {
                this.$toast.fail('服务器繁忙，请稍后尝试')
              }
          }).catch(err => {
              console.log(err)
          })
        },
        delImg (index) {
          // 删除指定下标的图片对象
          if (isNaN(index) || index >= this.fileList.length) {
            return false
          }
          let tmp = []
          for (let i = 0, len = this.fileList.length; i < len; i++) {
            if (this.fileList[i] !== this.fileList[index]) {
              tmp.push(this.fileList[i])
            }
          }
          this.fileList = tmp
        }
      },
    }
</script>

<style lang="less" scoped>
  .van-radio{
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 5px;
  }
  .container{
    .content {
      display: flex;
      flex-direction: row;
      padding: 12px;
      .messages {
        margin-left: 20px;
        .title1 {
          font-size: 13px;
          font-weight: 400;
          line-height: 18px;
          height: 36px;
          color: rgba(51, 51, 51, 1);
          overflow: hidden;
          word-wrap: break-word;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          flex: 1;
        }
        .price {
          height: 18px;
          line-height: 18px;
          font-size: 13px;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          padding: 10px 0;
        }
        .mehint {
          height: 18px;
          font-size: 12px;
          font-weight: 400;
          line-height: 17px;
          color: rgba(136, 137, 136, 1);
          background: rgba(243, 243, 243, 1);
          border-radius: 1px;
          padding: 1px 3px;
        }
      }
    }
    .title{
      padding: 10px;
      font-size:16px;
      font-family:PingFang SC;
      font-weight:500;
      line-height:22px;
      color:rgba(51,51,51,1);
      opacity:1;
    }
    .supplierA{
      height: 35px;
      width: 95%;
      margin-left: 2%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #F3F3F3;
      .suhint{
        font-size:14px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:20px;
        color:rgba(51,51,51,1);
        opacity:1;
      }
      .deadd{
        color: #C9C9C9;
        font-size: 20px;
      }
    }
    .refund-money{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 10px;
      border-bottom: 1px solid #F3F3F3;
      .refund-title{
        width: 100px;
      }
      .refund-value{
        flex: 1;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: #333333;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }
      .refund-input{
        border: none;
        text-align: left;
      }
    }
    .name{
      margin-left: 2%;
      font-size:14px;
      font-family:PingFang SC;
      font-weight:400;
      line-height:20px;
      color:rgba(51,51,51,1);
      opacity:1;
      margin-top: 12px;
      margin-bottom: 12px;
    }
    .uploadimg{
      width:85px;
      height:100px;
      background:rgba(246,246,246,1);
      border:1px solid rgba(243,243,243,1);
      opacity:1;
      border-radius:4px;
      margin-top: 20px;
      margin-left: 2%;
      .upload{
        font-size: 35px;
        text-align: center;
        line-height: 100px;
        color: #666666;
      }
    }
    .submit{
      width:95%;
      height:40px;
      margin-top: 145px;
      margin-bottom: 20px;
      margin-left: 2%;
      background:linear-gradient(0deg,rgba(244,4,66,1) 0%,rgba(226,23,75,0.73) 100%);
      opacity:1;
      border-radius:4px;
      line-height: 40px;
      text-align: center;
      font-size:16px;
      font-family:PingFang SC;
      font-weight:400;
      color:rgba(255,255,255,1);
    }
    .synopsis{
      width:90%;
      height:80px;
      background:rgba(255,255,255,1);
      border:1px solid rgba(243,243,243,1);
      opacity:1;
      border-radius:6px;
      margin-left: 2%;
      padding: 10px;
    }
    .popup{
      .popuphead{
        display: flex;
        justify-content: space-between;
      }
      .close{
        color: #C7C7C7;
        font-size: 25px;
        padding: 10px;
      }
      .confirm{
        padding: 10px;
        font-size:14px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:20px;
        color:rgba(254,0,59,1);
        opacity:1;
      }
      .active{
        color:rgba(254,0,59,1)!important;
      }
      .type{
        height: 45px;
        line-height: 45px;
        border-top: 1px solid #DDDDDD;
        font-size:14px;
        font-family:PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        opacity:1;
        text-align: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/mine/refund/writeRefund.vue